export const themes = [
  {
    name: 'Light',
    colors: {
      '--background': '0 0% 100%',
      '--foreground': '222.2 84% 4.9%',
      '--card': '0 0% 100%',
      '--card-foreground': '222.2 84% 4.9%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '222.2 84% 4.9%',
      '--primary': '187 85% 43%',
      '--primary-foreground': '210 40% 98%',
      '--secondary': '210 40% 96.1%',
      '--secondary-foreground': '222.2 47.4% 11.2%',
      '--muted': '210 40% 96.1%',
      '--muted-foreground': '215.4 16.3% 46.9%',
      '--accent': '210 40% 96.1%',
      '--accent-foreground': '222.2 47.4% 11.2%',
      '--destructive': '0 84.2% 60.2%',
      '--destructive-foreground': '210 40% 98%',
      '--border': '214.3 31.8% 91.4%',
      '--input': '214.3 31.8% 91.4%',
      '--ring': '215 20.2% 65.1%',
      '--radius': '0.75rem',
    },
  },
  {
    name: 'Dark',
    colors: {
      '--background': '222 47% 6%',
      '--foreground': '210 40% 98%',
      '--card': '222 47% 8%',
      '--card-foreground': '210 40% 98%',
      '--popover': '222 47% 10%',
      '--popover-foreground': '210 40% 98%',
      '--primary': '187 85% 53%',
      '--primary-foreground': '222 47% 6%',
      '--secondary': '222 47% 14%',
      '--secondary-foreground': '210 40% 98%',
      '--muted': '222 40% 18%',
      '--muted-foreground': '215 20% 55%',
      '--accent': '187 85% 53%',
      '--accent-foreground': '222 47% 6%',
      '--destructive': '0 72% 51%',
      '--destructive-foreground': '210 40% 98%',
      '--border': '222 40% 18%',
      '--input': '222 40% 18%',
      '--ring': '187 85% 53%',
    },
  },
];
